module.exports = __webpack_public_path__ + "media/src/application/media/v2-img-6-d1b5697498bd58a71d8c7ae5f7edb29f.png";